import { useMutation } from '@tanstack/react-query';

import { VerifyQrCodePayload } from '../../../../../types/requests';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { postConfirmQrCode } from '../../requests/postConfirmQrCode';

export const useConfirmQrCode = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (data: VerifyQrCodePayload) =>
      postConfirmQrCode(constructPost, data),
  });
  return { confirmQrCode: mutateAsync, ...rest };
};
